module.exports = __webpack_public_path__ + "img/Cerros.bcf1ab0f.jpg";